import React from 'react';
import { Navigation, NavigationProps } from './navigation';
interface NavigationLayoutProps extends NavigationProps {}

export function NavigationLayout({ children, ...props }: React.PropsWithChildren<NavigationLayoutProps>) {
    return <Navigation {...props}>{children}</Navigation>;
}
